<template>
  <div
    class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch"
  >
    <input
      v-model="model.text"
      type="text"
			ref="input_text"
      :placeholder="placeholder"
			@keypress.enter="onEnter"
      class="ts-px-3 ts-py-3 ts-placeholder-blueGray-300 ts-text-blueGray-600 ts-relative ts-border ts-border-gray-300 ts-bg-white ts-rounded ts-text-sm ts-border-1 ts-shadow ts-outline-none focus:ts-outline-none focus:ts-ring ts-w-full ts-pr-10"
    />
    <span
      class=" hover:ts-text-blue-600
				ts-cursor-pointer 
				ts-z-10 
				ts-h-full 
				ts-leading-snug 
				ts-font-normal 
				ts-absolute 
				ts-text-center 
				ts-text-blueGray-300 
				ts-bg-transparent 
				ts-rounded 
				ts-text-base 
				ts-items-center 
				ts-justify-center 
				ts-w-8 ts-right-0 
				ts-pr-3 ts-py-3
			"
			@click.prevent="onEnter"
		>
      <i class="fas fa-search" v-if="!waiting"></i>
			<i class="fas fa-spinner d-inline-block spin" v-else></i>
    </span>
  </div>
</template>
<script>
export default {
  props: {
		waiting: {
			type: Boolean,
			default: false
		},
		value : {
			type: Object,
		}
	},
  data() {
    return {
      model: {
        text: '',
      },
    }
  },
	mounted () {
		this.$refs.input_text.focus();
	},
  created() {
    this.model = this.value
  },
	computed: {
		placeholder() {
			return this.$t('productProfile.serial')
		}
	},
	methods: {
		onEnter() {
			this.$emit('onEnter')
		}
	},
}
</script>